/* ==========================================================================
   ACC_BN_LP_103 — Section 10: offer/buy-box commerce logic.
   Computes option pricing, manages selection, drives checkout permalink,
   and mirrors selected price/term into any [data-acc103-*] hooks page-wide
   (e.g. the footer CTA in section 13).
   ========================================================================== */
(function (section_name) {
  var root = document.querySelector("[data-acc103-offer]");
  if (!root) return;

  /* ---- Shopify money format ---- */
  function formatMoney(cents, format) {
    if (typeof cents === "string") cents = cents.replace(".", "");
    var value = "";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var fmt = format || "${{amount}}";
    function defaultTo(num, precision, thousands, decimal) {
      thousands = thousands === undefined ? "," : thousands;
      decimal = decimal === undefined ? "." : decimal;
      if (isNaN(num) || num == null) return 0;
      num = (num / 100).toFixed(precision);
      var parts = num.split(".");
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
      var cents2 = parts[1] ? decimal + parts[1] : "";
      return dollars + cents2;
    }
    switch ((fmt.match(placeholderRegex) || [])[1]) {
      case "amount": value = defaultTo(cents, 2); break;
      case "amount_no_decimals": value = defaultTo(cents, 0); break;
      case "amount_with_comma_separator": value = defaultTo(cents, 2, ".", ","); break;
      case "amount_no_decimals_with_comma_separator": value = defaultTo(cents, 0, ".", ","); break;
      case "amount_with_space_separator": value = defaultTo(cents, 2, " ", ","); break;
      case "amount_no_decimals_with_space_separator": value = defaultTo(cents, 0, " ", ""); break;
      default: value = defaultTo(cents, 2);
    }
    return fmt.replace(placeholderRegex, value);
  }

  function jparse(str, fallback) { try { return JSON.parse(str); } catch (e) { return fallback; } }

  var moneyFormat = root.getAttribute("data-money-format") || "${{amount}}";
  var variantId = root.getAttribute("data-variant-id");
  var available = root.getAttribute("data-available") === "true";
  var compareUnit = parseInt(root.getAttribute("data-compare"), 10) || 0;
  var oneTime = parseInt(root.getAttribute("data-price"), 10) || 0;
  var plans = jparse(root.getAttribute("data-plans"), {});
  var ctaTemplate = root.getAttribute("data-cta-template") || "[term] - [price]";

  var opts = {
    A: jparse(root.getAttribute("data-opt-a"), {}),
    B: jparse(root.getAttribute("data-opt-b"), {})
  };

  /* ---- compute per-option numbers ---- */
  function compute(o) {
    var subUnit = plans[o.plan];
    if (subUnit == null) subUnit = oneTime; // fallback if plan not found
    var price = Math.round(subUnit * (o.billed != null ? o.billed : o.qty));
    // Strike-through "compare" = the variant's regular (one-time) price × quantity.
    var compare = Math.round(oneTime * o.qty);
    // Savings % = difference of the calculated price vs the compare-at price × quantity.
    var compareAt = Math.round(compareUnit * o.qty);
    var savings = Math.max(0, compareAt - price);
    var savePct = compareAt > 0 ? Math.round((savings / compareAt) * 100) : 0;
    var perDay = o.days > 0 ? price / o.days : 0;
    return { price: price, compare: compare, savings: savings, savePct: savePct, perDay: perDay, term: o.term, qty: o.qty, plan: o.plan };
  }
  var calc = { A: compute(opts.A), B: compute(opts.B) };

  /* ---- fill each option card ---- */
  function fillCard(key) {
    var card = root.querySelector('[data-acc103-opt="' + key + '"]');
    if (!card) return;
    var c = calc[key];
    var set = function (field, val) {
      var el = card.querySelector('[data-acc103-opt-field="' + field + '"]');
      if (el) el.textContent = val;
    };
    set("price", formatMoney(c.price, moneyFormat));
    set("compare", formatMoney(c.compare, moneyFormat));
    set("perday", formatMoney(Math.round(c.perDay), moneyFormat) + " / day");
    set("save", "(Save " + c.savePct + "%)");
  }
  fillCard("A"); fillCard("B");

  /* ---- selection + mirror ---- */
  var selected = "A";

  function buildCheckoutHref(c) {
    var href = "/cart/" + variantId + ":" + c.qty;
    if (c.plan) href += "?selling_plan=" + c.plan;
    return href;
  }

  function applyTemplate(tpl, c) {
    return tpl.replace(/\[term\]/g, c.term || "").replace(/\[price\]/g, formatMoney(c.price, moneyFormat));
  }

  function select(key) {
    selected = key;
    var c = calc[key];
    // option card visual state + radios
    root.querySelectorAll("[data-acc103-opt]").forEach(function (card) {
      var on = card.getAttribute("data-acc103-opt") === key;
      card.classList.toggle("is-selected", on);
      var input = card.querySelector("input[type=radio]");
      if (input) input.checked = on;
    });
    // mirror selected values page-wide
    document.querySelectorAll("[data-acc103-price]").forEach(function (el) { el.textContent = formatMoney(c.price, moneyFormat); });
    document.querySelectorAll("[data-acc103-compare]").forEach(function (el) { el.textContent = formatMoney(c.compare, moneyFormat); });
    document.querySelectorAll("[data-acc103-term]").forEach(function (el) { el.textContent = c.term || ""; });
    document.querySelectorAll("[data-acc103-savings]").forEach(function (el) { el.textContent = formatMoney(c.savings, moneyFormat); });
    document.querySelectorAll("[data-acc103-perday]").forEach(function (el) { el.textContent = formatMoney(Math.round(c.perDay), moneyFormat) + " / day"; });
    // templated CTAs (each may carry its own data-cta-template)
    document.querySelectorAll("[data-acc103-cta]").forEach(function (el) {
      var tpl = el.getAttribute("data-cta-template") || ctaTemplate;
      el.textContent = applyTemplate(tpl, c);
    });
    // checkout links
    document.querySelectorAll("[data-acc103-checkout]").forEach(function (el) {
      if (available) {
        el.setAttribute("href", buildCheckoutHref(c));
        el.removeAttribute("aria-disabled");
      } else {
        el.setAttribute("href", "#");
        el.setAttribute("aria-disabled", "true");
      }
    });
  }

  root.querySelectorAll("[data-acc103-opt] input[type=radio]").forEach(function (input) {
    input.addEventListener("change", function () { select(input.value); });
  });
  root.querySelectorAll("[data-acc103-opt]").forEach(function (card) {
    card.addEventListener("click", function (e) {
      if (e.target.tagName !== "INPUT") select(card.getAttribute("data-acc103-opt"));
    });
  });

  /* ---- checkout (AJAX add -> /checkout), permalink as fallback ---- */
  function doCheckout(c) {
    if (!available || !c) return;
    var payload = { items: [{ id: parseInt(variantId, 10), quantity: c.qty }] };
    if (c.plan) payload.items[0].selling_plan = parseInt(c.plan, 10);
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify(payload)
    }).then(function () { window.location.href = "/checkout"; })
      .catch(function () { window.location.href = buildCheckoutHref(c); });
  }
  // dynamic checkout links follow the currently selected option
  document.addEventListener("click", function (e) {
    var link = e.target.closest("[data-acc103-checkout]");
    if (!link) return;
    e.preventDefault();
    doCheckout(calc[selected]);
  });

  /* ---- statically-bound CTAs: locked to one option, never change with the
     section-10 selection. e.g. section 13 footer CTA = option A "Bloomin
     Starter". Filled once here (text + checkout) and left untouched by select(). */
  document.querySelectorAll("[data-acc103-cta-static]").forEach(function (el) {
    var key = el.getAttribute("data-acc103-cta-static") || "A";
    var c = calc[key];
    if (!c) return;
    var tpl = el.getAttribute("data-cta-template") || ctaTemplate;
    el.textContent = applyTemplate(tpl, c);
    if (available) {
      el.setAttribute("href", buildCheckoutHref(c));
      el.removeAttribute("aria-disabled");
    } else {
      el.setAttribute("href", "#");
      el.setAttribute("aria-disabled", "true");
    }
    el.addEventListener("click", function (e) {
      e.preventDefault();
      doCheckout(c);
    });
  });

  /* ---- gallery is a Swiper (main synced to thumbnails) — see section liquid ---- */

  /* ---- stock counter: pick from the configured list by day of month (day 1 = 1st) ---- */
  (function stock() {
    var els = document.querySelectorAll("[data-acc103-offer] .acc103-10__stock-main, [data-acc103-stock]");
    if (!els.length) return;
    var nums = (root.getAttribute("data-stock-numbers") || "")
      .split(",")
      .map(function (s) { return s.trim(); })
      .filter(function (s) { return s !== ""; });
    if (!nums.length) return;
    var value = nums[(new Date().getDate() - 1) % nums.length];
    els.forEach(function (el) {
      if (/\[\d+\]/.test(el.textContent)) {
        el.textContent = el.textContent.replace(/\[\d+\]/, value);
      } else if (el.hasAttribute("data-acc103-stock")) {
        el.textContent = value;
      }
    });
  })();

  /* init */
  select("A");
})("acc_bn_lp_103_10");
